import { render } from "./ProductApplet.vue?vue&type=template&id=5f2f2bf3&scoped=true"
import script from "./ProductApplet.vue?vue&type=script&lang=js"
export * from "./ProductApplet.vue?vue&type=script&lang=js"

import "./ProductApplet.vue?vue&type=style&index=0&id=5f2f2bf3&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/simple-city-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f2f2bf3"]])

export default __exports__